import React from "react";
import { H3 } from "../../../styles/Headings.js";
import { P1, P2, P3 } from "../../../styles/Paragraphs.js";
import Section from "../../../styles/Section.js";
import { Highlight } from "../../../styles/Utilities.js";
import Image from "../../../components/Image";
import AboutIllustration from "../../../images/about-me-iilustration.svg";
import {
   AboutWrapper,
   AboutText,
   AboutSkills,
   SkillCard,
   Illustration
} from "./AboutSectionStyles.js";
import InView from "react-intersection-observer";

const illustrationVariant = {
   hidden: {
      y: 50,
      opacity: 0,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4
         },
         opacity: {
            duration: 0.4
         }
      }
   },
   visible: {
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4
         },
         opacity: {
            duration: 0.4
         }
      }
   }
};

function AboutSectionContainer() {
   return (
      <Section id="about" style={{ marginTop: "1rem" }}>
         <H3 center>
            <Highlight>About</Highlight> Me
         </H3>
         <AboutWrapper>
            <AboutText>
               <P2>
                  I am a <Highlight>Web Developer</Highlight> with an experience
                  of 2+ years, building personal and freelance projects. My main
                  area of expertise is MERN stack due to my keen interest in
                  javascript.
               </P2>
               <P2 style={{ margin: "1rem 0" }}>
                  I have worked as CTO in{" "}
                  <span style={{ fontWeight: 500 }}>"P-Spot: Parking App"</span>{" "}
                  where I was responsible for overall product requirement and
                  development. I structured & build the REST API and also
                  managed the React Native Frontend.
               </P2>
               <P2>
                  "There is always something to learn in life" - That's why I am
                  always learning and improving myself. I am looking for a job
                  to experience and discover new opportunities and challenges.
               </P2>
            </AboutText>
            <AboutSkills>
               <InView threshold={0.25}>
                  {({ ref, inView }) => (
                     <Illustration
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : ""}
                        variants={illustrationVariant}
                     >
                        <AboutIllustration className="image" />
                     </Illustration>
                  )}
               </InView>
            </AboutSkills>
         </AboutWrapper>
      </Section>
   );
}

export default AboutSectionContainer;
